module.exports = __webpack_public_path__ + "img/Feature.b67ea91f.jpg";